// ClawStinger Mock API & Data
const MOCK_USER = {
  id: 'usr_1a2b3c',
  email: 'demo@clawstinger.com',
  fullName: 'Alex Thompson',
  company: 'Acme Labs',
  avatar: null,
  timezone: 'America/New_York',
  plan: 'professional',
  creditBalance: 187.50,
  createdAt: '2025-11-15T10:00:00Z',
};

const MOCK_INSTANCES = [
  { id: 'inst_001', name: 'prod-assistant', tier: 'professional', region: 'us-east-1', status: 'running', ip: '45.33.21.100', cpu: 42, ram: 61, disk: 35, messages: 1247, uptime: '14d 6h 32m', clawVersion: '0.8.2', model: 'Claude Opus 4.5', channel: 'Telegram', createdAt: '2025-12-01' },
  { id: 'inst_002', name: 'dev-bot', tier: 'starter', region: 'eu-west-1', status: 'running', ip: '85.12.44.67', cpu: 18, ram: 32, disk: 12, messages: 342, uptime: '7d 2h 15m', clawVersion: '0.8.2', model: 'GPT-5.2', channel: 'Discord', createdAt: '2026-01-10' },
  { id: 'inst_003', name: 'client-alpha', tier: 'enterprise', region: 'ap-south-1', status: 'stopped', ip: '103.22.11.89', cpu: 0, ram: 0, disk: 48, messages: 8920, uptime: '0d 0h 0m', clawVersion: '0.8.1', model: 'Gemini 3 Flash', channel: 'WhatsApp', createdAt: '2025-10-05' },
  { id: 'inst_004', name: 'support-agent', tier: 'professional', region: 'us-west-2', status: 'running', ip: '52.88.33.21', cpu: 67, ram: 78, disk: 22, messages: 5633, uptime: '30d 18h 4m', clawVersion: '0.8.2', model: 'Claude Opus 4.5', channel: 'Slack', createdAt: '2025-09-20' },
];

const MOCK_SKILLS = [
  { id: 'sk_1', name: 'Gmail Integration', category: 'Productivity', installs: 12400, description: 'Read, send, and manage emails through Gmail API.', author: 'OpenClaw Team', verified: true },
  { id: 'sk_2', name: 'GitHub Manager', category: 'Developer', installs: 9800, description: 'Create PRs, manage issues, and automate workflows.', author: 'OpenClaw Team', verified: true },
  { id: 'sk_3', name: 'Calendar Sync', category: 'Productivity', installs: 8200, description: 'Manage Google Calendar events and reminders.', author: 'OpenClaw Team', verified: true },
  { id: 'sk_4', name: 'Notion Writer', category: 'Productivity', installs: 7100, description: 'Create and update Notion pages and databases.', author: 'community', verified: false },
  { id: 'sk_5', name: 'Web Scraper', category: 'Data', installs: 6500, description: 'Extract data from any website with smart parsing.', author: 'OpenClaw Team', verified: true },
  { id: 'sk_6', name: 'Spotify Control', category: 'Entertainment', installs: 5400, description: 'Control playback, create playlists, discover music.', author: 'community', verified: false },
  { id: 'sk_7', name: 'Hue Lights', category: 'Smart Home', installs: 4200, description: 'Control Philips Hue lights and scenes.', author: 'community', verified: false },
  { id: 'sk_8', name: 'Twitter Bot', category: 'Social', installs: 3800, description: 'Post tweets, monitor mentions, track trends.', author: 'community', verified: false },
  { id: 'sk_9', name: 'Sentry Monitor', category: 'Developer', installs: 3200, description: 'Track errors and auto-create fix PRs.', author: 'OpenClaw Team', verified: true },
  { id: 'sk_10', name: 'Invoice Generator', category: 'Business', installs: 2900, description: 'Create and send professional invoices.', author: 'community', verified: false },
  { id: 'sk_11', name: 'RSS Reader', category: 'Data', installs: 2600, description: 'Monitor RSS feeds and summarize articles.', author: 'community', verified: false },
  { id: 'sk_12', name: 'WHOOP Health', category: 'Health', installs: 2100, description: 'Track health metrics from WHOOP band.', author: 'community', verified: false },
];

const MOCK_INVOICES = [
  { id: 'inv_001', date: '2026-02-01', amount: 29.00, status: 'paid', plan: 'Professional', pdf: '#' },
  { id: 'inv_002', date: '2026-01-01', amount: 29.00, status: 'paid', plan: 'Professional', pdf: '#' },
  { id: 'inv_003', date: '2025-12-01', amount: 29.00, status: 'paid', plan: 'Professional', pdf: '#' },
  { id: 'inv_004', date: '2025-11-01', amount: 12.00, status: 'paid', plan: 'Starter', pdf: '#' },
  { id: 'inv_005', date: '2025-10-01', amount: 12.00, status: 'paid', plan: 'Starter', pdf: '#' },
];

const MOCK_BLOG_POSTS = [
  { id: 'blog_1', title: 'Introducing ClawStinger: Managed OpenClaw Hosting', slug: 'introducing-clawstinger', excerpt: 'Deploy your AI assistant in under 60 seconds.', category: 'Updates', date: '2026-02-10', readTime: '5 min' },
  { id: 'blog_2', title: 'How to Set Up Multi-Agent Workflows', slug: 'multi-agent-workflows', excerpt: 'Learn to orchestrate multiple OpenClaw agents for complex automation.', category: 'Tutorials', date: '2026-02-05', readTime: '8 min' },
  { id: 'blog_3', title: 'Customer Story: Agency Automation at Scale', slug: 'agency-automation', excerpt: 'How one agency uses ClawStinger to manage 15 client bots.', category: 'Case Studies', date: '2026-01-28', readTime: '6 min' },
  { id: 'blog_4', title: 'Understanding LLM Costs and Optimization', slug: 'llm-cost-optimization', excerpt: 'Practical tips for reducing your AI API spending.', category: 'Tutorials', date: '2026-01-20', readTime: '7 min' },
  { id: 'blog_5', title: 'Security Best Practices for AI Agents', slug: 'security-best-practices', excerpt: 'Keep your OpenClaw instance secure and private.', category: 'Tutorials', date: '2026-01-15', readTime: '10 min' },
];

const MOCK_STATUS_SERVICES = [
  { name: 'API Gateway', status: 'operational', uptime: 99.99 },
  { name: 'Instance Provisioning', status: 'operational', uptime: 99.95 },
  { name: 'RDP Access', status: 'operational', uptime: 99.97 },
  { name: 'Billing Service', status: 'operational', uptime: 100 },
  { name: 'Monitoring', status: 'degraded', uptime: 99.80 },
  { name: 'Backup Service', status: 'operational', uptime: 99.98 },
];

const MOCK_DOCS_SECTIONS = [
  { title: 'Getting Started', items: ['Quick Start Guide', 'System Requirements', 'Creating Your First Instance', 'Connecting Messaging Apps'] },
  { title: 'Instance Management', items: ['Hardware Tiers', 'Region Selection', 'Start/Stop/Restart', 'Scaling Up', 'Migration'] },
  { title: 'OpenClaw Configuration', items: ['AI Model Setup', 'API Key Management', 'Skills Installation', 'Memory Configuration', 'Persona Setup'] },
  { title: 'Remote Access', items: ['RDP Connection Guide', 'SSH Access', 'Browser Terminal', 'File Transfer', 'IP Whitelisting'] },
  { title: 'Billing & Credits', items: ['Subscription Plans', 'Credit System', 'Auto-Recharge', 'Invoices', 'Cost Optimization'] },
  { title: 'API Reference', items: ['Authentication', 'Instances API', 'Billing API', 'Analytics API', 'Webhooks'] },
];

const MOCK_TESTIMONIALS = [
  { name: 'jonahships_', text: "Setup ClawStinger yesterday. All I have to say is, wow. One click and my OpenClaw was running. No SSH, no server config, just works." },
  { name: 'markjaquith', text: "ClawStinger feels like that 'just had to glue all the parts together' leap forward for OpenClaw hosting. Incredible experience." },
  { name: 'danpeguine', text: "Why ClawStinger is nuts: your agent runs 24/7, you get RDP access, pre-configured everything. No DevOps needed." },
  { name: 'nateliason', text: "Yeah this was 1,000% worth it. Managing multiple agents from one dashboard, autonomously running tasks. The future is here." },
  { name: 'davemorin', text: "At this point I don't even know what to call it. After a few weeks, this is the first time I've felt like living in the future." },
  { name: 'karpathy', text: "Excellent platform. Love the simplicity and the power of managed OpenClaw hosting." },
];

const MOCK_ANALYTICS = {
  totalMessages: 16142,
  totalCost: 247.80,
  avgUptime: 99.7,
  activeInstances: 3,
  dailyMessages: Array.from({ length: 30 }, (_, i) => ({
    date: `Feb ${i + 1}`,
    messages: Math.floor(Math.random() * 800) + 200,
    cost: (Math.random() * 12 + 3).toFixed(2),
  })),
  costByInstance: [
    { name: 'prod-assistant', cost: 98.40 },
    { name: 'support-agent', cost: 87.20 },
    { name: 'dev-bot', cost: 42.10 },
    { name: 'client-alpha', cost: 20.10 },
  ],
};

// Simulated async delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const mockApi = {
  // Auth
  login: async (email, password) => { await delay(500); return { user: MOCK_USER, token: 'mock_jwt_token_123' }; },
  register: async (data) => { await delay(500); return { user: { ...MOCK_USER, email: data.email, fullName: data.fullName }, token: 'mock_jwt_token_123' }; },
  forgotPassword: async (email) => { await delay(500); return { message: 'Reset link sent' }; },
  resetPassword: async (token, password) => { await delay(500); return { message: 'Password reset successful' }; },

  // User
  getUser: async () => { await delay(200); return MOCK_USER; },
  updateUser: async (data) => { await delay(300); return { ...MOCK_USER, ...data }; },

  // Instances
  getInstances: async () => { await delay(300); return MOCK_INSTANCES; },
  getInstance: async (id) => { await delay(200); return MOCK_INSTANCES.find(i => i.id === id) || MOCK_INSTANCES[0]; },
  createInstance: async (data) => { await delay(1500); return { id: 'inst_new', ...data, status: 'provisioning', ip: '0.0.0.0' }; },
  startInstance: async (id) => { await delay(800); return { status: 'running' }; },
  stopInstance: async (id) => { await delay(800); return { status: 'stopped' }; },
  restartInstance: async (id) => { await delay(1000); return { status: 'running' }; },
  deleteInstance: async (id) => { await delay(500); return { success: true }; },

  // Skills
  getSkills: async () => { await delay(300); return MOCK_SKILLS; },
  installSkill: async (skillId, instanceId) => { await delay(1000); return { success: true }; },

  // Billing
  getInvoices: async () => { await delay(200); return MOCK_INVOICES; },
  getBillingOverview: async () => { await delay(200); return { plan: 'Professional', amount: 29, nextBillingDate: '2026-03-01', creditBalance: 187.50, paymentMethod: { brand: 'Visa', last4: '4242' } }; },
  purchaseCredits: async (amount) => { await delay(500); return { newBalance: MOCK_USER.creditBalance + amount }; },

  // Analytics
  getAnalytics: async () => { await delay(300); return MOCK_ANALYTICS; },

  // Blog
  getBlogPosts: async () => { await delay(200); return MOCK_BLOG_POSTS; },

  // Status
  getStatusServices: async () => { await delay(200); return MOCK_STATUS_SERVICES; },

  // Docs
  getDocsSections: async () => { await delay(100); return MOCK_DOCS_SECTIONS; },

  // Testimonials
  getTestimonials: async () => { await delay(100); return MOCK_TESTIMONIALS; },

  // Support
  submitTicket: async (data) => { await delay(500); return { ticketId: 'TKT-' + Math.random().toString(36).substr(2, 6).toUpperCase() }; },
};

export { MOCK_USER, MOCK_INSTANCES, MOCK_SKILLS, MOCK_INVOICES, MOCK_BLOG_POSTS, MOCK_STATUS_SERVICES, MOCK_DOCS_SECTIONS, MOCK_TESTIMONIALS, MOCK_ANALYTICS };
